import { jsx as _jsx } from "react/jsx-runtime";
import { debounce } from 'lodash';
import { useCallback, useMemo, useRef, useState, } from 'react';
import { v4 as uuidv4 } from 'uuid';
import BasicToastBody from './BasicToastBody.js';
import ToastContext from './ToastContext.js';
import { ToastEnum } from './ToastTypes.js';
const DEFAULT_TOAST_TIMEOUT = 8000; //ms
const NO_TIMEOUT = 0;
const ToastContextProvider = ({ children }) => {
    const [toasts, setToasts] = useState([]);
    const removalQueue = useRef([]);
    // TODO: object destructuring to omit type?
    const pushToast = useCallback((type, title, message, options = {}) => {
        const _duration = options.duration ?? (type === ToastEnum.Error ? NO_TIMEOUT : DEFAULT_TOAST_TIMEOUT);
        const id = uuidv4();
        setToasts((previous) => [
            ...previous,
            {
                id,
                component: BasicToastBody,
                props: {
                    id,
                    type: type,
                    title,
                    message,
                    duration: _duration,
                    distanceFormatLocale: options.distanceFormatLocale,
                    timestamp: new Date().valueOf(),
                },
            },
        ]);
        return id;
    }, [setToasts]);
    const pushRawToast = useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component, props) => {
        const id = uuidv4();
        setToasts((previous) => [
            ...previous,
            {
                id,
                component,
                // @ts-expect-error TODO: we want id to be optional in component but pass it in anyway
                props: {
                    id,
                    ...props,
                },
            },
        ]);
        return id;
    }, [setToasts]);
    const removeToasts = useMemo(() => 
    // not called during render
    // eslint-disable-next-line react-hooks/refs
    debounce(() => {
        setToasts((previous) => previous.filter((toast) => !removalQueue.current.includes(toast.id)));
        removalQueue.current = [];
    }, 3000), [setToasts]);
    const removeToast = useCallback((id) => {
        removalQueue.current.push(id);
        removeToasts();
    }, [removeToasts]);
    return (_jsx(ToastContext.Provider, { value: { toasts, pushToast, pushRawToast, removeToast }, children: children }));
};
export default ToastContextProvider;
//# sourceMappingURL=ToastContextProvider.js.map